import type {
  IExportRepository,
  ExportVisitsParams,
  ExportTasksParams,
  ExportStudySummaryParams,
  ExportSiteActivityParams,
  ExportMilestonesParams,
} from "../repositories/ExportRepository";

export interface IExportUseCase {
  exportVisits(params: ExportVisitsParams): Promise<Blob>;
  exportTasks(params: ExportTasksParams): Promise<Blob>;
  exportStudySummary(params: ExportStudySummaryParams): Promise<Blob>;
  exportSiteActivity(params: ExportSiteActivityParams): Promise<Blob>;
  exportMilestones(params: ExportMilestonesParams): Promise<Blob>;
}

export class ExportUseCase implements IExportUseCase {
  constructor(private readonly exportRepository: IExportRepository) {}

  async exportVisits(params: ExportVisitsParams): Promise<Blob> {
    return this.exportRepository.exportVisits(params);
  }

  async exportTasks(params: ExportTasksParams): Promise<Blob> {
    return this.exportRepository.exportTasks(params);
  }

  async exportStudySummary(params: ExportStudySummaryParams): Promise<Blob> {
    return this.exportRepository.exportStudySummary(params);
  }

  async exportSiteActivity(params: ExportSiteActivityParams): Promise<Blob> {
    return this.exportRepository.exportSiteActivity(params);
  }

  async exportMilestones(params: ExportMilestonesParams): Promise<Blob> {
    return this.exportRepository.exportMilestones(params);
  }
}
